import { DataTypes } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { EntryTypes } from "./entryType";
import { Modes } from "./mode";

export const dateOfLastCalibration: FieldSchema = {
  name: "dateOfLastCalibration",
  data: { type: DataTypes.DATE },
  display: {
    displayed: true,
  },
  form: {
    label: "Last calibration date",
    type: InputTypes.DATE,
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
  grid: {
    displayed: true,
    order: 78,
    ignoredForSearch: true,
  },
  // A getter rather than a `new Date()` literal, which would freeze "today" at the moment the
  // module was imported — a page load in the browser, but potentially days ago in a warm
  // Lambda container. `disabledCache` because the manager otherwise caches a structure's
  // result on the declared object itself, which outlives the manager that read it.
  validation: {
    maxDate: {
      getter: () => new Date(),
      fields: [],
      disabledCache: true,
    },
  },
};
